import { render, staticRenderFns } from "./EmailComposeReceived.vue?vue&type=template&id=613545e6&"
import script from "./EmailComposeReceived.vue?vue&type=script&lang=js&"
export * from "./EmailComposeReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports